<template>
  <section class="section">
    <h1 class="title">{{$t('welcome', 'Welcome')}}</h1>
    <p>{{$t('logged-in-as', { replace: { username }, defaultValue: `You are logged in as ${username}` })}}</p>
  </section>
</template>

<script>
import auth from '../auth'

export default {
  name: 'Welcome',
  computed: {
    username () {
      return auth.getUsername()
    }
  }
}
</script>
